import store from '@/store'
import Router from '@/router/index'
const HOME_ROUTE = {
  menu_name: '首页',
  alias_name: 'home',
  url: '/',
  name: '首页'
}
function getRouterVal ({ menu_name, alias_name, name, url } = {}) {
  return {
    menu_name,
    alias_name,
    name,
    url
  }
}
export function getMenusMap () {
  const menus = store.getters.menus
  const menusMap = store.getters.menusMap
  // for(let i of menus){
  //   menusMap[i.url] = getRouterVal(i)
  //   if(i.children&&i.children.length)
  //     for(let ii of i.children)
  //       menusMap[ii.url] = getRouterVal(ii)
  // }
  console.log('getRouter-menusMap', menusMap)
  return (path) => menusMap[path]
}
export function getRouter (path) {
  const menusMap = store.getters.menusMap
  // console.log('getRouter-menusMap',menusMap)
  // console.log('getRouter-path',path)
  if (path == '/' || path == '/auth/login') return HOME_ROUTE
  return getRouterVal(menusMap[path])
}
